import { Grid, Tooltip } from '@mui/material'
import { useWatch } from 'react-hook-form'

import { TextInput } from 'components/common'
import { CardTitle } from 'components/common/controls'
import { decimalFormatter, getBookingRevenue, getOtherChargesValue } from 'helpers'
import { Restricted } from 'providers'

import { ConsignmentFee } from './ConsignmentFee'
import { ConsignmentFeeFromTariff } from './ConsignmentFeeFromTariff'
import { DynamicPricing } from './DynamicPricing'

interface IProps {
  mode: number | undefined
  bookingId: number
  disabled?: boolean
  hoverText?: string
}

export const FeeAndCharges = (props: IProps) => {
  const { mode, bookingId, disabled, hoverText = '' } = props

  const [consignmentFee, chargesValue] = useWatch({
    name: ['consignmentFee', 'charges'],
  })

  const otherCharges = getOtherChargesValue(chargesValue)
  const otherChargesFormatted = decimalFormatter.format(otherCharges ?? 0)

  const totalFormatted = decimalFormatter.format(
    getBookingRevenue(Number(consignmentFee), otherCharges),
  )

  return (
    <Tooltip title={disabled ? hoverText : ''} followCursor>
      <>
        <CardTitle disabled={disabled}>Fee and Charges</CardTitle>
        <Grid container spacing={1.5}>
          <Grid item xs={12}>
            <ConsignmentFee mode={mode} disabled={disabled} />
          </Grid>

          <Grid item xs={12}>
            <TextInput
              name='otherCharges'
              label='Other Charges'
              value={otherChargesFormatted}
              disabled={disabled}
              readOnly
            />
          </Grid>

          <Grid item xs={12}>
            <TextInput
              name='total'
              label='Total'
              value={totalFormatted}
              disabled={disabled}
              readOnly
            />
          </Grid>

          <ConsignmentFeeFromTariff mode={mode} />

          <Restricted to='ViewConsignmentFeeFromDynamicPricing'>
            <DynamicPricing mode={mode} bookingId={bookingId} />
          </Restricted>
        </Grid>
      </>
    </Tooltip>
  )
}
